
<div>
  <h4>Send as Email Settings</h4>
  <div>
    <div class="label">Board-Email-Address</div>
    <input @input="isDirty = true" type="text" class="form-control" v-model="sendAsEmaiLConfig.emailAddress" />
  </div>

  <div class="mt-4">
    <div class="label">Board-Email-Sender</div>
    <input @input="isDirty = true" type="text" class="form-control" v-model="sendAsEmaiLConfig.emailSender" :placeholder="senderPlaceholder" />
  </div>

  <div class="mt-4">
    <div class="label">Default Signature</div>
    <wysiwig-editor :simple-mode="false" v-model="sendAsEmaiLConfig.emailSignature" @input="isDirty = true"></wysiwig-editor>
  </div>

  <hr />
  <div class="d-flex justify-content-end">
    <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save()">
      <i class="far fa-save"></i>
      Save changes
    </button>
  </div>
</div>
